import { generateUiRef } from 'features/securities/utils';

import { APIResponse } from '../../../../@types/api-response';
import { orderEndpoint } from '../constants/apiEndpoint';
import { getTradingApiInstance } from './instance/trading';

export const bulkCancelByOrderId = async (
  orderIds: string[],
): Promise<APIResponse> =>
  getTradingApiInstance().post(orderEndpoint.bulkCancelByOrderId, {
    ui_ref: generateUiRef(),
    order_id: orderIds,
  });

export const getOrderDetail = async (
  orderId: string,
): Promise<APIResponse<OrderItem>> =>
  getTradingApiInstance().get(orderEndpoint.orderDetail, {
    params: { order_id: orderId },
  });
